import type { ToolbarItemsPropType } from '@public-ui/components';
import { KolHeading, KolPopoverButton, KolToolbar } from '@public-ui/react-v19';
import type { FC } from 'react';
import React, { useEffect } from 'react';
import { useAlert } from '../../hooks/useAlert';
import { SampleDescription } from '../SampleDescription';

export const PopoverButtonBasic: FC = () => {
	const { dummyClickEventHandler } = useAlert();
	const buttonRef = React.useRef<HTMLKolPopoverButtonElement | null>(null);

	const dummyEventHandler = {
		onClick: dummyClickEventHandler,
	};

	const TOOLBAR_ITEMS: ToolbarItemsPropType = [
		{
			type: 'button',
			_label: 'Show',
			_icons: 'kolicon-eye',
			_on: dummyEventHandler,
		},
		{
			type: 'button',
			_label: 'Delete',
			_icons: 'kolicon-minus',
			_on: dummyEventHandler,
		},
		{
			type: 'button',
			_label: 'Add',
			_icons: 'kolicon-plus',
			_on: dummyEventHandler,
		},
	];

	useEffect(() => {
		// Ensure the popover is closed on initial render
		if (buttonRef.current) {
			buttonRef.current.showPopover();
			buttonRef.current.focus();
		}
	}, []);

	return (
		<>
			<SampleDescription>
				<p>
					The PopoverButton component combines a button with a popover that appears when clicked. The popover can be positioned in different directions (top,
					right, bottom, left) using the <code>_popoverAlign</code> prop.
				</p>
			</SampleDescription>
			<div className="flex flex-col gap-4 items-center">
				<KolPopoverButton _label={'Actions'} _variant="primary" _icons={{ right: 'kolicon-chevron-down' }} ref={buttonRef}>
					<KolToolbar _label="Action toolbar" _items={TOOLBAR_ITEMS} _orientation="vertical" />
				</KolPopoverButton>
				<KolPopoverButton _label="Help" _icons="kolicon-alert-info" _popoverAlign="right" _tooltipAlign="bottom" _hideLabel>
					<div className="w-sm p-2 border border-solid border-gray bg-white">
						<KolHeading _label="Help Information" _level={0}></KolHeading>
						<p>
							<u>Lorem ipsum dolor sit amet</u>, consectetur adipisicing elit. Aspernatur aut dolore dolores itaque praesentium reprehenderit sed voluptatum!
							Exercitationem ipsa magni maiores modi, placeat quas quos reprehenderit rerum sit veniam vitae.
						</p>
					</div>
				</KolPopoverButton>
			</div>
		</>
	);
};
